export interface SubscriptionOfferDto {
    id: string;
    organizationId: string;
    redeemed: boolean;
    redeemedOn: Date;
    redemptionEntityId: string;
    type: SubscriptionOfferType;
}

export enum SubscriptionOfferType {
    /**
     * No offer 
     */
    None = 0,
    /**
     * Entitles the organization to a 60-day trial of any Backstage plan
     */
    BackstageEarlyAdopterExtendedTrial = 1,
    /**
     * Entitles the organization to a 30-day trial of any Backstage plan
     */
    BackstageEarlyAdopter = 2,
    /**
     * Entitles the organization to a 14-day trial of any Backstage plan
     */
    BackstageTrial = 3,
    /**
     * Entitles an eligible organization to a one-time 14-day Backstage Pro retrial
     */
    BackstageRetrial = 4
}

const backstageTrialDays: Partial<Record<SubscriptionOfferType, number>> = {
    [SubscriptionOfferType.BackstageEarlyAdopterExtendedTrial]: 60,
    [SubscriptionOfferType.BackstageEarlyAdopter]: 30,
    [SubscriptionOfferType.BackstageTrial]: 14,
    [SubscriptionOfferType.BackstageRetrial]: 14,
};

export function getBackstageTrialDays(type: SubscriptionOfferType): number | undefined {
    return backstageTrialDays[type];
}

export function isBackstageTrialOffer(offer: SubscriptionOfferDto): boolean {
    return !offer.redeemed && getBackstageTrialDays(offer.type) !== undefined;
}

export function findAvailableBackstageRetrial(offers?: SubscriptionOfferDto[]): SubscriptionOfferDto | undefined {
    return offers?.find(offer => !offer.redeemed && offer.type === SubscriptionOfferType.BackstageRetrial);
}
